module.exports = __webpack_public_path__ + "img/data.52fd5039.png";